/*
 * @Description: 用户协议/隐私政策
 * @Date: 2024-12-12 11:39:23
 */

import { route } from './src/router/index';

const name = 'agree';

export { name, route };
